<template lang="pug">
  div 
    v-text-field(v-model="val" @focus="selecting=true" @blur="unfocus()" @input="emitValue" :label="label")
    div.autocomplete(v-if="selecting" )
      div.autocomplete-items
        div(v-for="item in topfixed" @click="setValue(item.val)") 
          span(v-for="(letter, index) in item.changed") 
              span.bold(v-if="letter == '*' ") {{val}}
              span(v-else) {{letter}}
    
</template>
<script>
export default {
  data: ()=>({
    val:'',
    selecting: false
  }),
  computed:{
    top(){
      let arr = []
      let that = this
      arr = this.items.filter(i=>{
        return i.toUpperCase().includes( that.val.toUpperCase() )
      } )
      return arr.splice(0,5)
    },
    topfixed(){
      let that = this
      let arr = []
      if (that.val.length > 0){
        this.top.forEach(word=>{
          let obj = {}
          obj.val = word
          obj.changed = word.replace(that.val,'*')
          arr.push(obj)
        })
      }
      return arr
    }

  },
  methods:{
    unfocus(){
      let that = this
      setTimeout(()=>{
        that.selecting = false
      }, 200)
    },
    emitValue(){
      this.$emit('setModel', this.val)
    },
    setValue(value){
      this.val = value
      this.emitValue()
    }
  },
  props:['items', 'label']
}
</script>
<style scoped>
.autocomplete {
  /*the container must be positioned relative:*/
  position: relative;
  /* display: inline-block; */
}
.autocomplete-items > div{
  padding: 10px;
  cursor: pointer;
  background-color: #fff; 
  border-bottom: 2px solid #d4d4d4; 
}
.autocomplete-items {
  position: absolute;
  border: 1px solid #d4d4d4;
  border-bottom: none;
  border-top: none;
  z-index: 99;
  /*position the autocomplete items to be the same width as the container:*/
  top: -19px;
  left: 0;
  right: 0;
}
.bold{
  font-weight : bold;
}
</style>

